import { Link } from "react-router-dom";
import { ArrowUpRight, PhoneCall } from "lucide-react";
import { Reveal } from "../Reveal";
import { CONTACT } from "../../data/content";

export const CTASection = () => (
  <section data-testid="cta-section" className="bg-background py-20 lg:py-28">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal>
        <div className="grain relative overflow-hidden rounded-3xl bg-brand px-8 py-16 text-white lg:px-16 lg:py-20">
          <div className="absolute -right-16 -top-16 h-64 w-64 rounded-full bg-aero/20 blur-3xl" aria-hidden="true" />
          <div className="relative max-w-2xl">
            <h2 className="font-display text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl text-balance">
              Ready to strengthen your aviation operation?
            </h2>
            <p className="mt-5 text-base leading-relaxed text-white/80 lg:text-lg">
              Book a consultation or request a capability discussion. We'll help you scope the
              right engagement across safety, compliance, operations, security and AI.
            </p>
            <div className="mt-9 flex flex-col gap-4 sm:flex-row">
              <Link
                to="/quote"
                data-testid="cta-quote-button"
                className="inline-flex items-center justify-center gap-1.5 rounded-full bg-aero px-7 py-3.5 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5"
              >
                Request a Quote <ArrowUpRight className="h-4 w-4" />
              </Link>
              <a
                href={`tel:${CONTACT.phone.replace(/\s/g, "")}`}
                data-testid="cta-call-button"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 bg-white/5 px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-white/10"
              >
                <PhoneCall className="h-4 w-4" /> {CONTACT.phone}
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
